import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CIVILISATION_ID } from '../../app/constants'
import { Info } from '../../assets/img'
import { setPopUp } from '../../features/popUpSlice/popUpSlice'
import { getEpoch } from '../../features/staking/epochSlice'
import useWax from '../../hooks/useWax'
import { cardCalculator } from '../../utilities/CardCalculator'
import { extractStake } from '../../utilities/extractStake'
import { Commander } from '../containers/Commander'
import { PercentageDisplay } from '../containers/PercentageDisplay'
import Button from '../ui/Button'
import { MissionDifficultyIndex } from '../ui/MissionDifficultyIndex'

const MissionDayOne = ({ civilisation }) => {
  const user = useSelector((state) => state.user)
  const epochInfo = useSelector((state) => state.epoch)
  const { stakeGLK } = useWax()

  const dispatch = useDispatch()

  const [selected, setSelected] = useState({ name: 'Mining', id: 1 })

  // Query Info for the selected Civilisation
  const epochCiv = epochInfo.epochDetails.filter(
    (i) => i.civilization === CIVILISATION_ID[civilisation],
  )

  // Query Info for the selected mission
  const epochCivMission = epochInfo.epochDetails.filter(
    (i) =>
      i.civilization === CIVILISATION_ID[civilisation] &&
      i.mission === selected.id,
  )

  // Query Info for user the selected mission
  const userEpochCivMission = epochInfo.userEpochDetails.filter(
    (i) => i.epoch_stake_id === epochCivMission[0].id
  );

  const userEpochCiv = epochInfo.userEpochDetails.filter((i) => {
    console.log(CIVILISATION_ID[civilisation])
    console.log(
      i,
      i.civilization === CIVILISATION_ID[civilisation] &&
        i.epoch_id === epochInfo.epoch_id,
    )
    return (
      i.civilization === CIVILISATION_ID[civilisation] &&
      i.epoch_id === epochInfo.epoch_id
    )
  })

  const missions = [
    { name: 'Mining', id: 1 },
    { name: 'Exploration', id: 2 },
    { name: 'Invention', id: 3 },
  ]

  // Calculate Percentages for each mission type
  const civTotals = []
  let civTotal = 0

  const missionPercentages = []

  function calculatePercentages() {
    epochCiv.forEach((item) => civTotals.push(extractStake(item.total_staked)))

    for (let i = 0; i < civTotals.length; i++) {
      civTotal = civTotal + civTotals[i]
    }

    civTotals.forEach((item) => {
      if (civTotal === 0) {
        missionPercentages.push(0)
      } else {
        missionPercentages.push(Math.round((item / civTotal) * 100))
      }
    })
  }

  calculatePercentages()

  // Query Existing User Stake

  const userStake = userEpochCiv[0]
    ? extractStake(userEpochCiv[0].total_staked)
    : 0

  useEffect(() => {
    setStakedAmount(userStake)
    if (userEpochCiv[0] && userStake > 0) {
      setSelected(missions[userEpochCiv[0].mission - 1])
      setHasStaked(true)
    } else {
      setHasStaked(false)
    }
  }, [civilisation])

  // Staking Actions

  const [stakedAmount, setStakedAmount] = useState(0)
  const [hasStaked, setHasStaked] = useState(false)

  const handleClick = (missionType, id) => {
    setSelected({ name: missionType, id })
  }

  const handleChange = (event) => {
    setStakedAmount(event.target.value)
  }

  const handleStake = (event) => {
    event.preventDefault()
    console.log("DEBUGGING STAKE:", selected, epochCivMission[0]?.id, userEpochCivMission)
    setHasStaked(true)
    const res = stakeGLK(
      epochCivMission[0]?.id,
      CIVILISATION_ID[civilisation],
      selected.id,
      stakedAmount,
    )
    if (res instanceof Error) {
      console.log(res)
      setHasStaked(false)
      setStakedAmount(0)
      setTimeout(() => dispatch(getEpoch(), 2000))
    } else {
      console.log(res)
      dispatch(getEpoch())
      calculatePercentages()
    }
  }

  const handleUpdatedStake = (event) => {
    event.preventDefault()
    const update = async () => {
      try {
        const result = await user.userAccount.signTransaction(
          {
            actions: [
              {
                account: 'gtokentest11',
                name: 'transfer',
                authorization: [
                  {
                    actor: user.userAccount.accountName,
                    permission: 'active',
                  },
                ],
                data: {
                  from: user.userAccount.accountName,
                  to: 'gtokenstakin',
                  quantity: `${
                    stakedAmount - extractStake(userEpochCiv[0].total_staked)
                  }.00000000 GLK`,
                  memo: `stake token@${epochCivMission[0].id}@${CIVILISATION_ID[civilisation]}@${selected.id}`,
                },
              },
            ],
          },
          {
            blocksBehind: 3,
            expireSeconds: 1200,
          },
        )
        console.log(result)
        dispatch(getEpoch())
      } catch (error) {
        console.log(userEpochCiv)
        console.log(error)
        setHasStaked(false)
        setStakedAmount(0)
      }
    }
    update()
  }

  const [cardNumber, setCardNumber] = useState(3)
  useEffect(() => {
    const result = cardCalculator(stakedAmount)
    setCardNumber(result)
  }, [stakedAmount])

  return (
    <section className="-mt-6 flex pb- overflow-x-hidden mx-auto lg:w-full md:flex-nowrap flex-wrap justify-center gap-3 p-4 md:p-0 md:pb-8 lg:px-4 xl:pr-10 pl-3 lg:pt-0 lg:pb-8 xl:pb-14 overflow-auto container__mission--grid">
      <div
        className="absolute top-[3%] right-[3%] cursor-pointer"
        onClick={() => dispatch(setPopUp({ isOpen: true, status: 'info-1' }))}
      >
        <Info />
      </div>
      <div className="hidden max-h-[45vh] 2xl:max-h-[50vh] lg:flex justify-center">
        <Commander civilisation={civilisation} />
      </div>
      <div className="lg:w-full w-full 2xl:pl-10 3xl:pl-12 md:w-1/2 col-span-2">
        <div className="grid gap-x-3 grid-cols-2  pt-7 xl:pt-10 3xl:pt-20">
          <div className="col-span-1 md:ml-4 md:mx-2 xl:mx-5 flex flex-col justify-between">
            <h3 className="text-cyanBlue uppercase self-center pb-4">
              Select Mission
            </h3>
            <div className="grid grid-rows-3 gap-y-4">
              <Button
                disabled={hasStaked}
                onClick={() => handleClick('Mining', 1)}
                responsive
                active={selected.name === 'Mining'}
                className="w-full"
              >
                Mining
              </Button>
              <Button
                disabled={hasStaked}
                responsive
                onClick={() => handleClick('Exploration', 2)}
                active={selected.name === 'Exploration'}
                className="w-full"
              >
                Exploration
              </Button>
              <Button
                disabled={hasStaked}
                responsive
                onClick={() => handleClick('Invention', 3)}
                active={selected.name === 'Invention'}
                className="w-full"
              >
                Invention
              </Button>
            </div>
          </div>
          <div className="col-span-1 xl:mr-10 flex flex-col justify-between">
            <h3 className="text-white self-center pb-4">Total GLK staked</h3>
            <div className="grid grid-rows-3 gap-y-4">
              <PercentageDisplay
                total
                mission={1}
                civilization={civilisation}
              />
              <PercentageDisplay
                total
                mission={2}
                civilization={civilisation}
              />
              <PercentageDisplay
                total
                mission={3}
                civilization={civilisation}
              />
            </div>
          </div>
        </div>

        <p className="text-cyanBlue mt-4 ml-4 lg:ml-5">{`${civilisation} ${selected.name} Mission Selected`}</p>
        <h3 className="md:mt-12 mt-6 mb-3  text-white ml-4 lg:ml-5 ">
          Enter GLK amount to stake
        </h3>
        <form className="grid grid-cols-2 lg:grid-cols-3 gap-x-3 md:ml-4 lg:ml-5 md:-mr-16 gap-y-4">
          <input
            type="number"
            value={stakedAmount}
            onChange={handleChange}
            className="bg-transparent rounded text-center text-white 2xl:py-2 py-1.5 border border-cyanBlue w-full"
          ></input>
          <Button
            active={!hasStaked}
            className="self-center w-full"
            uppercase
            responsive
            onClick={(event) => handleStake(event, selected)}
          >
            Stake
          </Button>
          <Button
            active={!!hasStaked}
            className="self-center w-full"
            uppercase
            responsive
            onClick={(event) => handleUpdatedStake(event, selected)}
          >
            Update Stake
          </Button>
        </form>
        <p className="text-white ml-4 lg:ml-5 mt-3">
          Your card limit will be
          <span className="text-cyanBlue"> {cardNumber}</span> per slot
        </p>
      </div>
      <div className="flex flex-col w-full lg:w-full items-center overflow-hidden  md:w-1/2 col-span-2">
        <MissionDifficultyIndex
          civilization={civilisation}
          selected={selected}
        />
      </div>
    </section>
  )
}

export default MissionDayOne
